import { cn } from '@/utils/cn';
import { useTranslation } from 'react-i18next';
import type { DentitionMode } from './ToothChartCanvas';

interface ToothChartDentitionToggleProps {
  value: DentitionMode;
  onChange: (mode: DentitionMode) => void;
  className?: string;
}

export function ToothChartDentitionToggle({ value, onChange, className }: ToothChartDentitionToggleProps) {
  const { t } = useTranslation();

  const options: { key: DentitionMode; label: string }[] = [
    { key: 'adult', label: t('dental.chart.dentition.adult', 'Voksen') },
    { key: 'child', label: t('dental.chart.dentition.child', 'Barn') },
    { key: 'mixed', label: t('dental.chart.dentition.mixed', 'Blandet') },
  ];

  return (
    <div
      className={cn(
        'inline-flex rounded-lg border border-ds-line bg-ds-sunk p-0.5 gap-0.5',
        className,
      )}
      role="group"
      aria-label="Tandtype"
    >
      {options.map(({ key, label }) => (
        <button
          key={key}
          type="button"
          onClick={() => onChange(key)}
          className={cn(
            'px-3 py-1.5 text-sm font-medium rounded-md transition-colors',
            value === key
              ? 'bg-ds-card bg-ds-sunk text-ds-text shadow-card'
              : 'text-ds-muted hover:text-ds-text',
          )}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
